export default __webpack_public_path__ + "static/media/falcon.1e00b424.png";